import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import { generateHelpId } from './utils';

function getBaseColumn({ scope }) {
  /**
   * Performance metrics base column.
   * @extends CampaignuiBaseColumn
   */
  return class PerformanceMetricBaseColumn extends CampaignuiBaseColumn {
    /**
     * Returns sortable property for the column config.
     * @param {Object} config column config
     * @returns {string} sortable property
     */
    static columnSortableProperty = config => config.property || `${scope}/${config.name}`;

    constructor(config) {
      const { i18n } = config;
      const helpId = generateHelpId(config);
      const property = config.property || `${scope}/${config.name}`;

      const schemaI18n = new SchemaI18n({ i18n });
      const title = config.title || schemaI18n.property(scope, _.last(property.split('/')));

      const localizedTitle = i18n && config.title ? i18n.getString(config.title) : title;

      super(_.defaults(
        { helpId, property, title },
        config,
        {
          type: 'number',
          sortable: PerformanceMetricBaseColumn.columnSortableProperty(config),
          helpAriaLabel: helpId && i18n
            ? i18n.getString('Click to learn more about {{item}}', { item: localizedTitle })
            : '',
        }
      ));
    }

    get title() {
      return this.config.title;
    }
  };
}

export const PerformanceMetricBaseColumn = getBaseColumn({
  scope: 'PerformanceMetrics',
});

export const PhonePerformanceMetricBaseColumn = getBaseColumn({
  scope: 'PhonePerformanceMetrics',
});
